import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Shield, ArrowLeft } from 'lucide-react';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/admin/auth/login', {
        email,
        password
      });

      // Store admin token
      localStorage.setItem('admin_token', response.data.access_token);
      localStorage.setItem('admin_role', response.data.role);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
      
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0A0F2A 0%, #1A1B2E 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="card"
        style={{ maxWidth: '450px', width: '100%', background: '#151827', border: '2px solid #DC2626' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Shield size={56} color="#DC2626" style={{ margin: '0 auto 1rem' }} />
          <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#DC2626' }}>ADMIN CONSOLE</h1>
          <p style={{ color: '#9CA3AF' }}>Master Control Panel</p>
        </div>

        {error && (
          <div className="alert alert-warning" style={{ marginBottom: '1.5rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Admin Email</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@astrowins.in"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Admin Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn"
            disabled={loading}
            style={{ 
              width: '100%', 
              marginTop: '1rem',
              background: 'linear-gradient(90deg, #DC2626 0%, #F59E0B 100%)',
              color: '#FFF',
              border: 'none'
            }}
          >
            {loading ? 'Authenticating...' : 'Admin Login'}
          </button>
        </form>

        <button
          onClick={() => navigate('/')}
          className="btn btn-ghost"
          style={{ width: '100%', marginTop: '1rem' }}
        >
          <ArrowLeft size={18} style={{ marginRight: '0.5rem' }} />
          Back to Main Site
        </button>

        <div style={{ marginTop: '2rem', padding: '1rem', background: 'rgba(220, 38, 38, 0.1)', borderRadius: '8px', fontSize: '0.875rem', color: '#9CA3AF' }}>
          <strong style={{ color: '#DC2626' }}>Default Credentials:</strong><br/>
          Email: admin@astrowins.in<br/>
          Password: Admin@123
        </div>
      </motion.div>
    </div>
  );
}

export default AdminLogin;
